import { Component } from "react";
import { Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import i18n from "../i18n";
import styles from "./UpdateAppDialog.module.scss";
import AppService from "../common/AppService";
import UpdateService from "../common/UpdateService";
import log from "loglevel";
import type { ModalChildProps } from './ModalComponent';

/**
 * Dialog component that reports a newer published version and offers going to
 * the store to update.
 *
 * Se abre una sola vez por version publicada.
 * @see App.noticeAppUpdate
 */
export default class UpdateAppDialog extends Component<ModalChildProps> {
    constructor(props: ModalChildProps) {
        super(props);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    // Needed to avoid aria-hidden warning when opening the modal from Drawer items.
    componentDidMount(): void {
        const active = document.activeElement as HTMLElement | null;
        if (active && active.blur) {
            active.blur();
        }
    }

    /**
     * Sends the user to the OS store and closes the dialog.
     *
     * Se cierra sin esperar a la tienda: la app se va a segundo plano, y al
     * volver no tiene sentido encontrarse el aviso todavia abierto.
     */
    handleUpdate(): void {
        UpdateService.goToStore(AppService.isIos()).catch((error) => {
            log.warn('UpdateAppDialog: store not opened', error);
        });
        this.handleClose();
    }

    /**
     * Closes the dialog without going to the store.
     *
     * La version queda dada por avisada igualmente: el aviso permanente es el
     * punto del boton de menu, y con el la entrada de actualizar del menu.
     */
    handleClose(): void {
        this.props.handleClose?.();
    }

    render() {
        return (
            <div className={styles.updateAppDialog}>
                {
                    // Partido en dos para que "Gronze Maps" quede entero en
                    // la segunda linea, como el mensaje de valorar la app.
                }
                <Typography variant="h6" className={styles.message}>
                    {i18n.t("updateApp.message1")}
                    <br/>
                    {i18n.t("updateApp.message2")}
                </Typography>
                <div className={styles.buttonsContainer}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleUpdate}
                    >
                        {i18n.t("updateApp.update")}
                    </Button>
                    <Button
                        variant="outlined"
                        color="default"
                        onClick={this.handleClose}
                    >
                        {i18n.t("updateApp.later")}
                    </Button>
                </div>
            </div>
        );
    }
}
